import React, { Fragment, useContext, useMemo } from 'react';

import '../styles/Breadcrumbs.css';
import { Link } from 'react-router-dom';
import FaChevronRight from '../icons/FaChevronRight';
import { BreadcrumbContext } from './context/BreadcrumbContext';
import { array, bool } from 'prop-types';

export default function Breadcrumbs({ breadcrumbList: customList = [], loading }) {
    const {
        breadcrumbList,
    } = useContext(BreadcrumbContext);
    const breadcrumbs = useMemo(() => {
        if (customList.length > 0) 
            return [
                ['Home', '/'],
                ...customList,
            ];
        return breadcrumbList ?? [];
    }, [customList, breadcrumbList]);
    return (<div
        className={`breadcrumbs${loading === true ? ' loading' : ''}`}>
        {
            breadcrumbs
                .filter((bread) => Array.isArray(bread)
                    && bread.length === 2)
                .map((bread, idx, arr) => (<Fragment
                    key={idx}>
                    <Link
                        to={bread[1]}
                        className={'breadcrumbs--item'}>{bread[0]}</Link>
                    {(idx !== arr.length - 1) && (<span
                        className={'breadcrumbs--item-next'}>
                        <FaChevronRight
                            style={{ verticalAlign: 'baseline' }}
                            size={'10px'} />
                    </span>)}
                </Fragment>))
        }
    </div>);
}

Breadcrumbs.propTypes = {
    breadcrumbList: array,
    loading: bool,
};

Breadcrumbs.defaultProps = {
    loading: false,
};